import { render } from "./EnvelopePage.vue?vue&type=template&id=053cfed4&scoped=true"
import script from "./EnvelopePage.vue?vue&type=script&lang=js"
export * from "./EnvelopePage.vue?vue&type=script&lang=js"

import "./EnvelopePage.vue?vue&type=style&index=0&id=053cfed4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-053cfed4"]])

export default __exports__